import { ReactNode } from 'react';
import { Section } from '../../Section/Section';
import {
  useAvroTracking,
  SectionName,
  CtaGoal,
  CtaName,
  EventName,
  useTrackEvent,
  EventAction,
  InteractionName,
} from '../../../observability';
import { Carousel } from '../../Carousel/Carousel';
import { BuilderComponentProps } from '../../../builder';

type Props = {
  children: ReactNode;
  heading: string;
  subheading: string;
} & BuilderComponentProps;

export function CarouselSection(props: Props) {
  const { emitUserInteractionEvent } = useAvroTracking();
  const trackEvent = useTrackEvent();

  const handleActiveSlideChange = (
    currentSlide: number,
    previousSlide: number,
  ) => {
    emitUserInteractionEvent({
      event_action: EventAction.click,
      interaction_name: InteractionName.carousel_button_click,
      option_selected: currentSlide > previousSlide ? 'next' : 'previous',
      custom_tracking_fields: {
        section_name: SectionName.CarouselSection,
      },
    });
    trackEvent(EventName.CALL_TO_ACTION, {
      path: window.location.pathname,
      from_path: document.referrer,
      cta_name: CtaName.moreArticles,
      cta_raw_text: 'click_arrow',
      cta_goal: CtaGoal.getMoreInformation,
    });
  };
  return (
    <Section
      contentWidth="overflow"
      heading={props.heading}
      layerName={props.builderBlock?.layerName}
      sectionToTrack={SectionName.CarouselSection}
      subheading={props.subheading}
    >
      <Carousel onActiveSlideChange={handleActiveSlideChange}>
        {props.children}
      </Carousel>
    </Section>
  );
}
